module.exports = __webpack_public_path__ + "static/media/ros.b34755de.png";